import React from "react";
import { Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import OrderDetails from "../../AdminEventView/EventOrders/OrderDetails";

/**
 * CRM layout for orders: list at /crm/orders, detail at /crm/orders/:organizationId/:orderId.
 * Renders an Outlet so either CRMOrders (index) or order detail is shown.
 */
export function CrmOrdersLayout() {
  return <Outlet />;
}

/**
 * CRM order detail view. Wraps OrderDetails in a Container.
 * OrderDetails detects CRM via URL and hides the cancel button and uses back to /crm/orders.
 */
export default function CrmOrderDetailsPage() {
  return (
    <Container>
      <OrderDetails />
    </Container>
  );
}
